import React, { Component } from "react";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { languages } from "../../constants/languages";
import DeleteDialog from "../../components/DeleteDialog";

class DeleteBracketContainer extends Component {
  state = {
    open: false,
    errorMessage: "",
    warningShown: false,
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      this.setState({ open: !this.state.open, errorMessage: "" });
    }
  };

  handleDelete = () => {
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    tournamentRef
      .collection("matches")
      .where("bracket", "==", this.props.bracketId)
      .get()
      .then((querySnapshot) => {
        var hasScheduledMatches = false;
        querySnapshot.forEach(function (doc) {
          let match = doc.data();
          if (match.field !== null) {
            hasScheduledMatches = true;
          }
        });
        if (hasScheduledMatches && !this.state.warningShown) {
          this.setState({
            errorMessage: languages.tournament.areYouSure,
            warningShown: true,
          });
        } else {
          if (this.props.subBracketsArray.length > 0) {
            this.setState({
              errorMessage: languages.structure.deleteSubBracketsFirstError,
            });
          } else if (this.props.tournament.scheduleLocked) {
            this.setState({
              errorMessage: languages.structure.scheduleLockMessage,
            });
          } else {
            this.props.handleDelete();
            this.toggleDialog();
          }
        }
      });
  };

  render() {
    return (
      <div>
        <IconButton
          aria-label="Delete"
          onClick={this.toggleDialog}
          style={{
            color: "white",
            width: 30,
            height: 20,
          }}
        >
          <DeleteIcon style={{ height: 20, position: "absolute", top: 2 }} />
        </IconButton>
        <DeleteDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleDelete={this.handleDelete}
          title={languages.structure.deleteBracket}
          description={languages.structure.deleteBracketWarning}
          errorMessage={this.state.errorMessage}
        />
      </div>
    );
  }
}

export default DeleteBracketContainer;
